exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".k8azW2arfLG_LUwmq7waU {\n  background-color: var(--tab-highlight-color);\n  width: fit-content;\n  padding: 4px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n._1QImLqCSqNeyrwWSxkCV6G {\n  color: var(--primary-text-color);\n  font-size: 12px;\n}\n", ""]);

// Exports
exports.locals = {
	"participantBadge": "k8azW2arfLG_LUwmq7waU",
	"participantName": "_1QImLqCSqNeyrwWSxkCV6G"
};